import { useEffect, useState } from "react";

/**
 * Sans anti-rebond, chaque frappe déclenche une requête sur un million de
 * lignes. 300 ms suffisent à ne garder que la frappe utile.
 */
export function useDebounce<T>(valeur: T, delai = 300): T {
  const [retardee, setRetardee] = useState(valeur);
  useEffect(() => {
    const t = setTimeout(() => setRetardee(valeur), delai);
    return () => clearTimeout(t);
  }, [valeur, delai]);
  return retardee;
}
